import type { FC, PropsWithChildren, ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

interface BasicModalProps {
  title?: string;
  footerContent?: ReactNode;
  show: boolean;
  size?: 'sm' | 'lg' | 'xl' | undefined;
  handleClose: () => void;
}

export const BasicModal: FC<PropsWithChildren<BasicModalProps>> = ({
  title,
  show,
  handleClose,
  children,
  size = 'sm',
  footerContent,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size={size}>
      <Modal.Header style={{ borderBottom: 'none' }} closeButton>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer style={{ borderTop: 'none', marginTop: '20px' }}>
        {footerContent && footerContent}
      </Modal.Footer>
    </Modal>
  );
};
